import React from 'react'
import styled from '@emotion/styled'
import Image from 'next/image'
import Modal from './Modal'
import Button from './Button'
import { Header2 } from '../../../../styles/Components'
import { gsColors } from '../../../../styles/Variables'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 0 40px 32px 40px;

  button {
    background-color: ${gsColors.sunsetOrange};
    padding: 0 2rem;
    margin: 1rem;
  }
`

const PriceNotification = ({
  isOpen,
  close
}) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={close}
      width="375px"
      isDesktop={true}
      customStyles={{
        top: '25%',
      }}
    >
      <Container>
        <Image src='/svg/price-notification.svg' alt='price notification' width={48} height={48} />
        <Header2
          fontSize={20}
          align="center"
          lineHeight="140%"
          margin="1rem 2rem"
        >
          Service prices now include all fees.
        </Header2>
        <Button
          onClick={close}
          fill
        >
          Got it
        </Button>
      </Container>
    </Modal>
  )
}

export default PriceNotification
